import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserModel } from '@common/models/User.model';
import { AttachmentService } from '@common/services/attachment.service';
import { FileDownloadService } from '@common/services/file-download.service';
import { PcsDocumentAndApprovalServices } from '@common/services/pcs-document-and-approval-services.service';
import { currentUserSubject } from '@common/services/user.service';
import { VesselVisitService } from '@common/services/vessel-visit.service';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-attachment-list-dialog',
    templateUrl: './attachment-list-dialog.component.html',
    styleUrls: ['./attachment-list-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AttachmentListDialogComponent implements OnInit {
    user: UserModel;
    currentUser$: Subscription;
    public attachments: any[] = [];

    public pcsDocumentAndApprovalStatusId: string;
    public pcsAttachments = [];
    public customsHoldAttachments = [];
    public faqDocumentAttachments = [];
    public notificationAttachments = [];
    public draftSurveyAttachments = [];
    public openedAttachmentId = null;
    public currentlyRemovingAttachmentId = -1;
    public removeAttachmentDialog = false;

    public get isPcsMode(): boolean {
        return this.pcsAttachments?.length > 0;
    }

    constructor(
        private fileDownloadService: FileDownloadService,
        private service: PcsDocumentAndApprovalServices,
        private vesselVisitService: VesselVisitService,
        private attachmentService: AttachmentService,
        public activeModal: DialogRef
    ) {}

    ngOnInit(): void {
        if (!this.pcsAttachments || this.pcsAttachments.length === 0) {
            const genericAttachments = [
                this.draftSurveyAttachments,
                this.customsHoldAttachments,
                this.faqDocumentAttachments,
                this.notificationAttachments
            ].find((list) => list?.length > 0);

            if (genericAttachments) {
                this.attachments = genericAttachments;
            }
        }
    }

    public openRemoveAttachmentDialog(attachmentId: number) {
        this.removeAttachmentDialog = true;
        this.currentlyRemovingAttachmentId = attachmentId;
    }

    public closeRemoveAttachmentDialog() {
        this.removeAttachmentDialog = false;
        this.currentlyRemovingAttachmentId = -1;
    }

    attachmentDownload(id: number): void {
        this.service.downloadAttachment(id).subscribe((response) => {
            this.fileDownloadService.handleAttachmentDownload(response);
        });
    }

    submitRemoveAttachment() {
        if (this.pcsAttachments && this.pcsAttachments.length > 0) {
            this.service
                .removeAttachment({
                    isForApproval: false,
                    attachmentId: this.currentlyRemovingAttachmentId
                })
                .subscribe(() => {
                    this.pcsAttachments = this.pcsAttachments.filter(
                        (x) => x.id !== this.currentlyRemovingAttachmentId
                    );
                    this.removeAttachmentDialog = false;
                    this.activeModal.close('deleted');
                });
        } else if (this.draftSurveyAttachments && this.draftSurveyAttachments.length > 0) {
            this.attachmentService
                .removeAttachment({
                    ids: [this.currentlyRemovingAttachmentId],
                    entity: 'DraftSurvey'
                })
                .subscribe(() => {
                    this.draftSurveyAttachments = this.draftSurveyAttachments.filter(
                        (x) => x.id !== this.currentlyRemovingAttachmentId
                    );
                    this.removeAttachmentDialog = false;
                    this.activeModal.close('deleted');
                });
        }
    }

    belongsToOrganization(organization: any): boolean {
        const user = currentUserSubject.getValue();
        if (!user || !organization) {
            return false;
        }
        return user.belongsToOrganization(organization);
    }

    downloadAttachment(data: any) {
        if (data) {
            this.fileDownloadService.handleAttachmentDownload(data);
        }
    }
}
